import React from 'react';
import Icon from 'components/Icon';

type EstimateAccordionProps = {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  onRemove?: () => void;
  canRemove?: boolean;
  children: React.ReactNode;
};

const EstimateAccordion: React.FC<EstimateAccordionProps> = ({
  title,
  isOpen,
  onToggle,
  onRemove,
  canRemove = false,
  children,
}) => {
  return (
    <div className="bg-[#F6F6F8] rounded-lg border border-border-lighter">
      <div
        className="flex justify-between items-center px-2 py-3 cursor-pointer"
        onClick={onToggle}
      >
        <div className="text-lg font-bold">{title}</div>
        <Icon
          name={isOpen ? 'caret-up-outline' : 'caret-down-outline'}
          size={28}
          className="text-text"
        />
      </div>
      {/* Keep content mounted to preserve state, just hide it when closed */}
      <div className={isOpen ? 'px-4 pb-4' : 'hidden'}>
        {children}
        {canRemove && onRemove && (
          <div
            className="flex justify-end space-x-1 cursor-pointer mt-4"
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
          >
            <Icon name="delete" size={14} className="text-error" />
            <div className="text-xs font-medium text-error">Remove</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EstimateAccordion;
